import { useState } from "react";
import axios from "axios";

export const useApi = () => {
  // Vite environment variables (use VITE_ prefix)
  const meta = import.meta;
  // const baseURL = meta.env?.VITE_API_URL || meta.env?.VITE_PUBLIC_API_URL;
  // const defaultOrigin = meta.env?.VITE_ORIGIN || meta.env?.VITE_PUBLIC_ORIGIN;

   const baseURL = import.meta.env.VITE_API_URL;
  const defaultOrigin = import.meta.env.VITE_ORIGIN;

  console.log("base",baseURL);
  
  const [state, setState] = useState({
    data: null,
    loading: false,
    error: null,
  });

  const getHeaders = (isFormData = false) => {
    return {
      Authorization: "",
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      Accept: "application/json",
      "Custom-Origin": defaultOrigin,
      ...(defaultOrigin ? { Origin: defaultOrigin } : {}),
      "Cache-Control": "no-cache",
    };
  };

  const callApi = async (endpoint, payload, method = "POST", headers) => {
    setState({ data: null, loading: true, error: null });

    try {
      const isFormData = payload instanceof FormData;
      const url = `${baseURL}${endpoint}`;
      const response = await axios({
        url,
        method,
        data: payload,
        headers: { ...getHeaders(isFormData), ...headers },
      });
      setState({ data: response.data, loading: false, error: null });
      return response.data;
    } catch (err) {
      let errorMsg = "Something went wrong";
      // Type guard for error with response
      if (typeof err === "object" && err !== null) {
        if (
          "response" in err &&
          typeof err.response?.data?.message === "string"
        ) {
          errorMsg = err.response?.data?.message ?? errorMsg;
        } else if ("message" in err && typeof err.message === "string") {
          errorMsg = err.message ?? errorMsg;
        }
      }
      setState({
        data: null,
        loading: false,
        error: errorMsg,
      });
      throw err;
    }
  };

  return { ...state, callApi };
};
